import { Routes, Route, Outlet } from "react-router-dom";
import ClientsContextProvider from "../context/ClientsContextProvider";
import ClientsList from "../pages/ClientsList";
import NewClient from "../pages/NewClient";
import ClientDetails from "../pages/ClientDetails";
import { useContext } from "react";
import { MainContext } from "../../../main/context/MainContextProvider";
import EmptyStateNotFound from "../components/EmptyState";

export default function ClientsRoutes() {
  const { userIsAdm } = useContext(MainContext);
  return (
    <>
      <ClientsContextProvider>
        <Routes>
          <Route path="/" element={<ClientsList />} />
          <Route path="/:id" element={<ClientDetails />} />
          {userIsAdm && (
            <>
              <Route path="/cadastrar" element={<NewClient />} />
              <Route path="/:id/editar" element={<NewClient />} />
            </>
          )}
          <Route path="/*" element={<EmptyStateNotFound />} />
        </Routes>
        <Outlet />
      </ClientsContextProvider>
    </>
  );
}
